export default class BranchUser {
  itemId = 0
  itemName = ''
  itemNameParts = []
  type = ''
  searchData = ''
  visitorType = null
  branchId = null

  constructor (rawData = {}) {
    if (rawData.C_branch_item_id_primary) {
      this.branchId = rawData.C_branch_item_id_primary
    }
    if (rawData.item_id !== undefined) {
      this.itemId = rawData.item_id
    }
    if (rawData.itemId !== undefined) {
      this.itemId = rawData.itemId
    }

    if (rawData.item_name !== undefined) {
      this.itemName = rawData.item_name
      this.itemNameParts = rawData.item_name.split(' ')
    }

    if (rawData.itemName !== undefined) {
      this.itemName = rawData.itemName
      this.itemNameParts = rawData.itemName.split(' ')
    }

    this.type = rawData.type

    if (rawData.search_data !== undefined) {
      this.searchData = rawData.search_data
    }
    if (rawData.searchData !== undefined) {
      this.searchData = rawData.searchData
    }

    if (rawData.visitor_type !== undefined && rawData.visitor_type !== '') {
      this.visitorType = rawData.visitor_type
    }

    if (rawData.visitorType !== undefined && rawData.visitorType !== '') {
      this.visitorType = rawData.visitorType
    }
  }

  get visitorData () {
    return { visitor_id: this.itemId, visitor_role: this.type }
  }
}
